import React from "react";

const AirbagImage = ({ width = 192, height = 100, scale = 1, text = 8, data }) => {
  if ((data || []).length === 0) return null;

  const hasFrontAirbag = (title: string) => {
    // return data;
    return data.some((item: { title; value }) => item.title === title && item.value !== "-");
  };

  return (
    <div className='flex items-center justify-center w-full' style={{ height: height }}>
      <div className='relative w-full' style={{ height: height }}>
        <img
          className='flex mx-auto'
          style={{ width: width, height: height }}
          src='https://photo.8891.com.tw/2024/09/09/1725871927769945.png'
          alt=''
        />


        {hasFrontAirbag("膝部氣囊-主駕駛座") && (
          <div className={`absolute left-0 flex items-center`} style={{ bottom: 26 * scale }}>
            <span
              className={`text-[#333] text-center`}
              style={{ fontSize: text, marginRight: text === 8 ? "" : "24px" }}
            >
              膝部氣囊
            </span>
            <img
              style={{ width: 70 * scale }}
              src='https://photo.8891.com.tw/2024/09/13/1726210110921227.png'
              alt='膝部氣囊'
            />
          </div>
        )}

        {hasFrontAirbag("膝部氣囊-副駕駛座") && (
          <div className={`absolute left-0 flex items-center`} style={{ bottom: 56 * scale }}>
            <span
              className={`text-[#333] text-center`}
              style={{ fontSize: text, marginRight: text === 8 ? "" : "24px" }}
            >
              膝部氣囊
            </span>
            <img
              style={{ width: 70 * scale }}
              src='https://photo.8891.com.tw/2024/09/13/1726210110921227.png'
              alt='膝部氣囊'
            />
          </div>
        )}


        {hasFrontAirbag("前座中央氣囊") && (
          <div className='absolute left-0 flex items-center' style={{ bottom: 40 * scale }}>
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px" }}
            >
              前座中央
              <br />
              氣囊
            </span>
            <img
              style={{ width: 110 * scale, marginLeft: 6 * scale }}
              src='https://photo.8891.com.tw/2024/09/09/1725873883893159.png'
              alt='前座中央氣囊'
            />
          </div>
        )}


        {hasFrontAirbag("後排安全帶氣囊") && (
          <div className='absolute right-0 flex items-center' style={{ bottom: 30 * scale }}>
            <img
              style={{ width: 46 * scale, height: 36 * scale }}
              src='https://photo.8891.com.tw/2024/09/09/1725874743459372.png'
              alt='後排安全帶氣囊'
            />
            <span
              className='text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginLeft: text === 8 ? "" : "30px" }}
            >
              後排安全帶
              <br />
              氣囊
            </span>
          </div>
        )}

        {hasFrontAirbag("後座側面氣囊") && (
          <div className='absolute flex items-center flex-col' style={{ bottom: -30 * scale, right: 44 * scale }}>
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginRight: -40 * scale }}
            >
              後座側面氣囊
            </span>
            <img
              style={{ width: 43 * scale, height: 131 * scale, marginTop: 4 * scale, marginBottom: 4 * scale }}
              src='https://photo.8891.com.tw/2024/09/09/1725876123183402.png'
              alt='後座側面氣囊'
            />
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginRight: -40 * scale }}
            >
              後座側面氣囊
            </span>
          </div>
        )}

        {hasFrontAirbag("側面氣簾") && (
          <div className='absolute flex items-center flex-col' style={{ bottom: -30 * scale, right: 77 * scale }}>
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginRight: -28 * scale }}
            >
              側面氣簾
            </span>
            <img
              style={{ width: 62 * scale, height: 131 * scale, marginTop: 4 * scale, marginBottom: 4 * scale }}
              src='https://photo.8891.com.tw/2024/09/09/1725877044700711.png'
              alt='側面氣簾'
            />
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginRight: -28 * scale }}
            >
              側面氣簾
            </span>
          </div>
        )}
        {hasFrontAirbag("前座側面氣囊") && (
          <div className='absolute flex items-center flex-col' style={{ bottom: -30 * scale, right: 109 * scale }}>
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginLeft: -26 * scale }}
            >
              前座側面氣囊
            </span>
            <img
              style={{ width: 46 * scale, height: 131 * scale, marginTop: 4 * scale, marginBottom: 4 * scale }}
              src='https://photo.8891.com.tw/2024/09/09/1725877408825246.png'
              alt='前座側面氣囊'
            />
            <span
              className=' text-[#333] text-center '
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginLeft: -26 * scale }}
            >
              前座側面氣囊
            </span>
          </div>
        )}
        {hasFrontAirbag("前座正面氣囊") && (
          <div className='absolute  flex items-center flex-col' style={{ bottom: -30 * scale, left: 43 * scale }}>
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginLeft: -50 * scale }}
            >
              前座正面氣囊
            </span>
            <img
              style={{ width: 76 * scale, height: 131 * scale, marginTop: 4 * scale, marginBottom: 4 * scale }}
              src='https://photo.8891.com.tw/2024/09/09/1725877699519207.png'
              alt='前座正面氣囊'
            />
            <span
              className=' text-[#333] text-center'
              style={{ fontSize: text, lineHeight: text === 8 ? "8px" : "22px", marginLeft: -50 * scale }}
            >
              前座正面氣囊
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AirbagImage;
